import { useEffect, useState } from "react";
import { initializeOffice, type OfficeEnvironment } from "@/office/officeReady";

export interface UseOfficeResult extends OfficeEnvironment {
  ready: boolean;
}

export function useOffice(): UseOfficeResult {
  const [environment, setEnvironment] = useState<OfficeEnvironment>({
    host: null,
    platform: null,
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    void initializeOffice().then((result) => {
      if (!active) return;
      setEnvironment(result);
      setReady(true);
    });
    return () => {
      active = false;
    };
  }, []);

  return { ...environment, ready };
}
